fragment UserFragment on User {
  id
  login
  slug
  role
  picture
  animatedPicture
  isPremium
}